import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from '@workspace/ui/components/dialog';
import { cn } from '@workspace/ui/lib/utils';

const Modal = ({
  open,
  onOpenChange,
  children,
  title,
  hideCloseBtn = false,
  closeOnOverlayClick = true,
  className = '',
  contentId,
  headerClassName = '',
  fullWidthModal = false,
  dialogOverlayClassName = '',
  titleClassName = '',
  description = '',
  descriptionClassName = '',
  closeBtnClassName = '',
  ...props
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  title?: any;
  hideCloseBtn?: boolean;
  closeOnOverlayClick?: boolean;
  className?: string;
  contentId?: string;
  headerClassName?: string;
  fullWidthModal?: boolean;
  dialogOverlayClassName?: string;
  titleClassName?: string;
  description?: string;
  descriptionClassName?: string;
  closeBtnClassName?: string;
  // Phones only: fixed sheet height as a fraction of the visible screen.
  mobileHeight?: number;
  [key: string]: any;
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        id={contentId}
        className={cn(
          'block z-51 space-y-4 w-full sm:w-[calc(100%-32px)] max-h-[90dvh] sm:max-h-[85dvh]',
          fullWidthModal ? 'sm:max-w-305' : '',
          className,
        )}
        onInteractOutside={(e) => {
          if (!closeOnOverlayClick) {
            e.preventDefault();
          }
        }}
        hideCloseBtn={hideCloseBtn}
        // A modal that must not close by accident shouldn't close on a stray swipe either.
        swipeToClose={closeOnOverlayClick}
        overlayClassName={dialogOverlayClassName}
        closeBtnClassName={closeBtnClassName}
        {...props}
      >
        <DialogHeader className={title || description ? headerClassName : 'sr-only'}>
          {title ? (
            <DialogTitle
              className={cn(
                'relative text-primary-darker text-lg text-left capitalize',
                titleClassName,
              )}
            >
              {title}
            </DialogTitle>
          ) : (
            <DialogTitle>Dialog</DialogTitle>
          )}

          {description ? (
            <DialogDescription className={cn('', descriptionClassName)}>
              {description}
            </DialogDescription>
          ) : null}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
